import { type FC } from "react";

import { Menu } from "@styled/menu";
import { MenuButtonEllipsis } from "@styled/menu_button_ellipsis";
import { MenuItemButton } from "@styled/menu_item_button";
import { MenuItems } from "@styled/menu_items";

// A Drafting section's ··· menu. Remove names where it goes from: his
// template while the case is on it, else this case.
export const DraftingSectionMenu: FC<{
  onTemplate: boolean;
  onEdit(): void;
  onRemove(): void;
}> = ({ onTemplate, onEdit, onRemove }) => (
  <Menu>
    <MenuButtonEllipsis />
    <MenuItems anchor="bottom end" fit>
      <MenuItemButton size="sm" onClick={onEdit}>
        Edit section
      </MenuItemButton>
      <MenuItemButton size="sm" destructive onClick={onRemove}>
        {onTemplate ? "Remove from template" : "Remove from this case"}
      </MenuItemButton>
    </MenuItems>
  </Menu>
);
